module.exports = __webpack_public_path__ + "assets/img/3210.8df79cdb.png";